export enum ElementIds {
	popis = 'popis-title',
	priloha = 'priloha-title',
	adresat = 'adresat-title',
	zakladatel = 'zakladatel-kontakt-title',
	peticniVybor = 'peticni-vybor-title',
}
